/**
 * HOOK: useAssociationsSelect
 * Hook léger pour charger uniquement les associations nécessaires aux selects
 *
 * ⚡ Optimisation: Ne charge que id + name
 */

import { useSelectData } from './useSelectData';

interface AssociationSelectItem {
  id: string;
  name: string;
}

interface UseAssociationsSelectReturn {
  associations: AssociationSelectItem[];
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

export function useAssociationsSelect(): UseAssociationsSelectReturn {
  const { data, loading, error, refresh } = useSelectData('associations', 'id, name', 'name', true);

  return {
    associations: data as AssociationSelectItem[],
    loading,
    error,
    refresh,
  };
}
